import React, { useContext } from "react";
import LockIcon from "../../../../components/SVGComponents/LockIcon";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import userContext from "../../../../context/users/UserContext";
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";

const LockWarning = (props) => {

  const { roles, username, authenticated, loadByUsername, userId, qcReviewer } =
  useContext(userContext);

  const { getAlterColor } = useContext(themeContext);

  const {
    showLockWarning,
    lockStudy,
    showLockButton,
    alreadyLocked,
    setShowReturnStudyModal,
    reportDoneStatusState,
    hideLockWarningMessage,
    lockedByOther
  } = useContext(studyReportContext);
  // const {assignmentData} = useContext(studyviewerContext);
  return (<>
     <div className="lock-warning-section">
      {!alreadyLocked && <p style={{color: getAlterColor("#FFE144","#0078D4"),visibility:(showLockWarning && !hideLockWarningMessage)?"visible":"hidden"}} className="lock-warning-text no-margin">
        {lockedByOther?t("string-literals.not-locked-study"):t("string-literals.not-allowed-submit-report")} &nbsp;
      </p>
      }
      {alreadyLocked && <p style={{color: getAlterColor("#7af156","#0078D4")}} className="unlock-warning-text no-margin">
        This study is locked {(reportDoneStatusState == 2 && reportDoneStatusState != null)?" and submitted":""} by you. &nbsp;
      </p>}
      {!props.isStudyList && <div id="timerDisplayOnReportingPanel" className = "expiration-timer-text" style={{display:"none"}}></div> }
    </div></>
  );
};

export default LockWarning;
